<ngb-datepicker *ngIf="inline;else popup" [(ngModel)]="date" (dateSelect)="onDateSelected()" #d="ngbDatepicker">
</ngb-datepicker>
<ng-template #popup>
  <div class="input-group">
    <input type="text" class="form-control" [(ngModel)]="date" name="date"
      (dateSelect)="onDateSelected()" ngbDatepicker #d="ngbDatepicker">
    <div class="input-group-append">
      <button class="btn btn-outline-secondary fa fa-calendar-alt" (click)="d.toggle()" type="button"></button>
    </div>
  </div>
</ng-template>
